import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Box, Button, ListItemIcon, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'
import { t } from 'ttag'

interface CopyPasteProductPricingProps {
  onCopyPricingPlans: () => void
  onPastePricingPlans: () => void
  copiedPricingPlansExist: boolean
  domicileClass?: string
}

function CopyPasteProductPricing({
  onCopyPricingPlans,
  onPastePricingPlans,
  copiedPricingPlansExist,
  domicileClass
}: Readonly<CopyPasteProductPricingProps>) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isCopyPasteMenuOpen = Boolean(anchorEl)

  const openCopyPasteMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const closeCopyPasteMenu = () => {
    setAnchorEl(null)
  }

  const handleCopyPricingPlans = () => {
    onCopyPricingPlans()
    setAnchorEl(null)
  }

  const handlePastePricingPlans = () => {
    onPastePricingPlans()
    setAnchorEl(null)
  }

  return (
    <Box>
      <Button
        size="small"
        color="inherit"
        endIcon={<MoreVertIcon />}
        aria-label={t`Copy or paste cells`}
        onClick={openCopyPasteMenu}
      >
        {t`Copy/paste`}
      </Button>
      <Menu anchorEl={anchorEl} onClose={closeCopyPasteMenu} open={isCopyPasteMenuOpen}>
        <MenuItem key="copy" onClick={handleCopyPricingPlans}>
          <ListItemIcon>
            <ContentCopyIcon fontSize="small" />
          </ListItemIcon>
          {domicileClass ? t`Copy domicile class cells` : t`Copy cells`}
        </MenuItem>
        <MenuItem key="paste" onClick={handlePastePricingPlans} disabled={!copiedPricingPlansExist}>
          <ListItemIcon>
            <ContentPasteIcon fontSize="small" />
          </ListItemIcon>
          {domicileClass ? t`Paste copied domicile class cells` : t`Paste copied cells`}
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default CopyPasteProductPricing
